import type { AxiosError } from 'axios';
import { MAX_RETRY_ATTEMPTS } from './constants/retry-policy-constants';


const RETRYABLE_4XX_STATUS_CODES = new Set<number>([408, 429]);

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRY_ATTEMPTS) {
    return false;
  }

  // React Query types `error` as `unknown`; narrow to AxiosError to inspect HTTP status.
  // No `axios.isAxiosError` import to keep this pure / tree-shakeable.
  const status = (error as AxiosError | undefined)?.response?.status;

  if (status === undefined) {
    return true;
  }

  if (status >= 400 && status < 500) {
    return RETRYABLE_4XX_STATUS_CODES.has(status);
  }

  return true;
}
